import * as React from 'react';
import { ModalFullscreen } from '@cian/ui-kit/modal';
import * as style from './styles.css';
import { modalFullscreen } from '../../constants/gallery';
import { Layout } from '../Layout';

export interface IFullscreenGalleryProps {
  header: React.ReactNode;
  content: React.ReactNode;
  onClose(): void;
}

export function FullscreenGallery({ onClose, header, content }: IFullscreenGalleryProps) {
  return (
    <ModalFullscreen open escape onClose={onClose} theme="white">
      <div className={style['container']} id={modalFullscreen}>
        <div className={style['header']}>{header}</div>
        <div className={style['content']}>
          <Layout>{content}</Layout>
        </div>
      </div>
    </ModalFullscreen>
  );
}
